const jpg = 'fmt=jpg';
const fit = 'fit=constrain,0';
export const getPosterImageUrl = ({ posterimage, serverurl, width }) => {
    const url = `${posterimage}&wid=${width}&${jpg}&${fit}`;
    return posterimage.startsWith('http') ? url : `${serverurl}${url}`;
};
//# sourceMappingURL=get-poster-image.js.map